// extracted by mini-css-extract-plugin
module.exports = {"form":"form-view_form__3IImn","input":"form-view_input__swTh6"};